import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskTelefone'
})
export class TelefonePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    const digits = value.replace(/\D/g, '');

    if (digits.length === 11) {
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    }

    if (digits.length === 10) {
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
    }

    return value;
  }
}
